// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__n3kLl","imageUploader":"EGiftCard_imageUploader__1S6Hm"};